import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import * as authenticationTypes from '../../types';
import { IMessage, IPortalInfo } from '../../../shared/types';

@Component({
  selector: 'tr-mfa-auth-selector',
  templateUrl: './mfa-auth-selector.component.html',
  //styleUrls: ['./mfa-auth-selector.component.scss']
})
export class MfaAuthSelectorComponent implements OnInit {
  @Output() mfaType = new EventEmitter<any>();
  @Input() isBusy: boolean;
  @Input() message: IMessage;
  @Input() portalInfo: IPortalInfo;
  
  private mfaTypeMsg: string = "";

  constructor() { }

  ngOnInit() {
  }

  onMfaTypeSelected(event) {
    switch(event.target.value) {
      case 'app':
        this.mfaTypeMsg = 'Authentication requires you to download and install the Google Authenticator App or Microsoft Authenticator App. You can download either app from the Google Play or the iPhone App Store. More instructions are provided in the next step once you click the Continue button below.';
        break;

      case 'email':
        this.mfaTypeMsg = 'Please note, once you select the authenticator app, it becomes your permanent method of authentication. If you continue via the email verification method, you will be provided with the opportunity to set up the authenticator app the next time you log in.';
        break;

      default:
        this.mfaTypeMsg = '';
        break;
    }
  }

  saveMFAType(mfaAuthType: string) {
    let mfaAuthTypeData = {
      mfaAuthType: mfaAuthType
    }
    this.mfaType.emit(mfaAuthTypeData);
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/components/mfa-auth-selector/mfa-auth-selector.component.ts